.container {
    height: 400px;
    display: flex;
    position: relative;
}
